import React, { useEffect } from "react";
import { bool, string } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { getAdSlots } from "../utils";

const DfpComponent = ({
  slotId,
  type = "",
  refreshAdUnit = false,
  className = "",
  collectionSlug,
  layoutName = "DefaultLayout",
}) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adsConfig = get(qtState, ["config", "ads-config", "dfp_ads"], {});

  if (!slotId || !type) {
    return null;
  }

  const {
    sizes: size,
    adUnit: path,
    viewPortSizeMapping,
    renderOutOfThePage,
  } = get(qtState, ["config", "ads-config", "slots", type], {});
  const { delay_ad_load: delayAdLoad = 4, load_ads_synchronously: loadAdsSynchronously = true } = adsConfig;

  useEffect(() => {
    getAdSlots({
      path,
      size,
      id: slotId,
      qtState,
      type,
      layoutName,
      viewPortSizeMapping,
      loadAdsSynchronously,
      delayPeriod: delayAdLoad * 0,
      renderOutOfThePage,
      refreshAdUnit,
      collectionSlug,
    });
  }, [type, slotId]);

  return (
    <div className="dfp-ad-unit">
      <div className="adunitContainer">
        <div className={`${className} adBox`} id={slotId} />
      </div>
    </div>
  );
};

DfpComponent.propTypes = {
  slotId: string,
  type: string,
  refreshAdUnit: bool,
  className: string,
  layoutName: string,
  collectionSlug: string,
};

export { DfpComponent };
